import type { StatusIconCheckTone } from "@/components/statusIcon/statusIcon.component";

import type { SanityCompetitorCompareCell } from "./compareCompetitorTable.type";

export function competitorCellToIconValue(
  cell: SanityCompetitorCompareCell | undefined,
): CompetitorCompareCellValue {
  const display = cell?.display ?? "text";
  if (display === "text") {
    return cell?.text?.trim() || "—";
  }
  return display === "included" || display === "competitorIncluded";
}

export function competitorCellCheckTone(
  cell: SanityCompetitorCompareCell | undefined,
): StatusIconCheckTone {
  return cell?.display === "competitorIncluded" ? "competitor" : "adt";
}

/** Cell value for competitor compare UI: check, X, or custom text */
export type CompetitorCompareCellValue = boolean | string;
